module.exports = __webpack_public_path__ + "static/media/google-drive.93a111b9.png";